<template>
  <select
    v-if="loaded"
    v-model="selected"
    class="plainfieldselect"
    :class="selectStyle"
    :name="name"
  >
    <option :value="{ short: '', title: '' }">Please Select...</option>
    <option v-for="state in usStates" :key="state.short" :value="state">
      {{ state.title }}
    </option>
  </select>
</template>

<script lang="ts" setup>
import states from "../assets/us_states.json";
import { State } from "@/models/State";
import { onMounted, ref, computed, Ref, ComputedRef } from "vue";

const props = defineProps({
  initial: {
    default: new State(),
  },
  selectStyle: {
    default: "",
  },
  name: {
    default: "",
  },
});
const value: Ref<any> = ref(new State());
const loaded: Ref<boolean> = ref(false);
const emit = defineEmits(["input"]);

const selected = computed({
  get: () => value.value,
  set: (newValue: string) => {
    (value.value = newValue), emit("input", newValue);
  },
});

const usStates: ComputedRef<any> = computed(() => {
  return states.states;
});

onMounted(() => {
  value.value = props.initial;
  loaded.value = true;
});
</script>
